/**
 *  Copyright 2018 Avaya Inc. All Rights Reserved.
 *
 * Usage of this source is bound to the terms described in
 * licences/License.txt
 *
 * Avaya - Confidential & Proprietary. Use pursuant to your signed agreement or
 * Avaya Policy
 *
 * Defines the client end of the WebSocket chat.
 */
import chatUI from "./webChatUI"
import webChat from "./webChat"
import chatConfig from "./webChatConfig"
import widgetConfig from "./webChatConfig"
import avayaGlobal from "./avayaGlobal"
import chatLogon from "./webChatLogon"
import chatSocket from "./webChatSocket"
import links from "./links"

import ewt from "./estimatedWaitTime"
import jQuery from 'jquery'
import $ from 'jquery'
import  'jquery-ui/ui/widgets/dialog';
import Vue from 'vue'
import http from "../../../http-common"
import Chat from "../../../components/Chat"

export default {

    users : {},
    chatBotName : '',

    guid : null,
    ak : null,
    webOnHoldComfortGroups : null,
    webOnHoldURLs : null,

    onHoldUrlInterval : null,
    onHoldComfortInterval : null,
    pingInterval : null,

    isTyping : false,
    typeOut : null,
    activeAgentTypeOut : null,
    passiveAgentTypeOut : null,
    supervisorTypeOut : null,
    usersTable : null,
    lastIsTypingSent : Date.now(),
    timeBetweenMsgs : 10000,

    initCalled : false,
    autoOpen : false,

    isFeedbackShow: false,
    sentFeedback: false,
    isCreateJourney: false,
    journeyCustomerId: 0,

    timeouts : [],

    // holds details such as names, etc.
    custDetails : {},

    customerFeedback : {"agentId":"", "agentName":"", "chatsessionId":"" , "customerName":"", "customerContact":"",
        "customerFeedback":"NULL", "actionTime":"", "chatStartDate":"", "chatEndDate":"", "contactId":"", "skillset":"",
        "chatDuration":"", "email":"", "channel":"", "mobileOrWeb":"", "lang":"", "source":"", "appName":"", "appVersion":"", "complaintReason":"", "complaintText":""},

    // custom data for chatbot
    customData: {},

    workflowType : '',
    routePointIdentifier : 'Default',

    agentConnected: false,
    agentWaiting: true,
    agentDisconnected: false,

    messageList: [],

    parsedMessageList: [],

    /**
     * Append a specified link to the chat transcript.
     *
     * @param url
     * @param urlDestination
     * @param openAutomatically -
     *                false for Web-On-Hold URLs, but URLs from an agent may be
     *                changed
     * @param parentElement -
     *                the parent element
     */
    appendLink : function(url, urlDestination, openAutomatically, parentElement) {
        'use strict';
        var link = document.createElement('a');
        link.href = url;
        link.text = url;
        link.target = ('_' + urlDestination);
        parentElement.appendChild(link);

        if (openAutomatically) {
            window.open(link);
        }
    },

    /**
     * Log the user into the chat.
     */
    chatLogin : function() {
        'use strict';
        var wantsEmail = Vue.prototype.$config.wantsEmail;
        var topic = chatUI.getTopic();
        var leaseTime = chatConfig.leaseTime;
        console.log('WebChat: Chat attributes are ', JSON.stringify(chatLogon.attributes));

        // if the user didn't specify a valid email address, they can't
        // receive a transcript.
        if (avayaGlobal.isStringEmpty(this.custDetails.email)) {
            wantsEmail = false;
        }
        var calledParty = window.location.href;
        var msg;
        var custDetails = this.custDetails;

        this.customerFeedback.customerName = custDetails.firstName + " " + custDetails.lastName;


        this.customerFeedback.customerContact= "+" + custDetails.phone.country + (custDetails.phone.country === "971" ? custDetails.phone.area : "") + custDetails.phone.number;

        this.customerFeedback.email = custDetails.email;
        this.customerFeedback.skillset = chatLogon.skillSetCode;

        if (!chatConfig.previouslyConnected) {

            msg = {
                'apiVersion' : '1.0',
                'type' : 'request',
                'body' : {
                    'method' : 'requestChat',
                    'deviceType' : navigator.userAgent,
                    'routePointIdentifier' : this.routePointIdentifier,
                    'workFlowType' : this.workflowType,
                    'requestTranscript' : wantsEmail,
                    'workRequestId' : avayaGlobal.getSessionStorage('contextId'),
                    'calledParty' : calledParty,
                    'leaseTime' : leaseTime,
                    'intrinsics' : {
                        'channelAttribute' : 'Chat',
                        'textDirection' : document.dir.toUpperCase(),
                        'attributes' : chatLogon.attributes,
                        'email' : custDetails.email,
                        'name' : custDetails.firstName,
                        'lastName' : custDetails.lastName,
                        'country' : custDetails.phone.country,
                        'area' : custDetails.phone.area,
                        'phoneNumber' : custDetails.phone.number,
                        'topic' : topic
                    },
                    'priority' : ewt.getPriority(),
                    'customData': this.customData
                }
            };

            ////this.writeResponse(chatConfig.openingChatText, chatConfig.writeResponseClassSystem);
        } else {
            // check if this is continuing after a page refresh or just a network glitch
            // if this is a page refresh, then we will request the full transcript
            var isAfterRefresh = custDetails.isContinuingAfterRefresh;
            console.log("Is this after a refresh?", isAfterRefresh);

            msg = {
                'apiVersion' : '1.0',
                'type' : 'request',
                'body' : {
                    'method' : 'renewChat',
                    'guid' : this.guid,
                    'authenticationKey' : this.ak,
                    'requestFullTranscript' : isAfterRefresh
                }
            };
        }
        chatSocket.sendMessage(msg);
    },

    /**
     * Clears all timeouts on the page.
     */
    clearAllTimeouts : function() {
        'use strict';
        for (var i = 0; i < this.timeouts.length; i++) {
            clearTimeout(this.timeouts[i]);
        }
    },

    /**
     * Clears the customer's typing timeout.
     *
     * @param obj
     */
    clearTypingTimeout : function(obj) {
        'use strict';
        if (obj) {
            clearTimeout(obj);
        }
    },

    /**
     * Handles notification messages.
     *
     * @param message
     */
    handleNotification : function(message) { // NOSONAR: too complex
        // for Sonar, but cannot be reduced further
        'use strict';
        var body = message.body, method = body.method;
        if (method === chatConfig.jsonMethodRequestChat) {
            this.notifyRequestChat(body);
        } else if (method === chatConfig.jsonMethodRouteCancel) {
            this.notifyRouteCancel();
        } else if (method === chatConfig.jsonMethodRequestNewParticipant) {
            this.customerFeedback.agentId = body.agentId;
            this.customerFeedback.agentName = body.displayName;
            console.log('this.customerFeedback.agentName:', this.customerFeedback.agentName)

            this.notifyNewParticipant(body);
        } else if (method === chatConfig.jsonMethodRequestIsTyping) {
            this.notifyIsTyping(body);
        } else if (method === chatConfig.jsonMethodRequestNewMessage) {
            this.notifyNewMessage(body);
        } else if (method === chatConfig.jsonMethodRequestCloseConversation) {
            this.notifyCloseConversation();
        } else if (method === chatConfig.jsonMethodRequestParticipantLeave) {
            this.notifyParticipantLeave(body);
        } else if (method === chatConfig.jsonMethodRequestNewPushMessage) {
            this.notifyNewPagePushMessage(body);
        }else if (method === chatConfig.jsonMethodPing) {
            // do nothing with pings. They just confirm that the
            // WebSocket is open.
        } else if (method === chatConfig.jsonMethodFileTransfer) {
            if(Vue.prototype.$config.attachmentIsActive)this.notifyFileTransfer(body);
        } else {
            throw new TypeError('Received notification with unknown method: '.concat(method));
        }
    },

    /**
     * Initialise the chat.
     * @param {Boolean} disableControls - defines whether or not to disable the controls. If true, the user will not be able to type a message
     */
    initChat : function(disableControls, custDetails) {
        'use strict';
        console.log('initChat')
        // if the chat has already opened, don't bother opening it
        if (this.initCalled) {
            return;
        }

        if (disableControls === undefined) {
            disableControls = true;
        }

        this.custDetails = custDetails;
        chatUI.disableControls(disableControls);
        chatSocket.openSocket();
        this.initCalled = true;

        //this.setupWebChat()
        $("#comments").on("keydown", this.onType);
    },

    /**
     * Notify the user that the chat is closed.
     *
     * @param body
     */
    notifyCloseConversation : function() {
        'use strict';
        // Server will close the websocket
        chatSocket.manualClose = false;
        chatConfig.dontRetryConnection = true;
        avayaGlobal.clearSessionStorage();
    },

    /**
     * Reset the chat.
     */
    resetChat : function() {
        'use strict';
        chatUI.resetChatUI();
        webChat.updateUsers();
        webChat.clearAllTimeouts();

        this.ak = null;
        this.guid = null;
        this.lastIsTypingSent = 0;
        chatSocket.resetWebSocket();
        chatConfig.dontRetryConnection = false;
        //$("#chatFeedback").show();
    },

    /**
     * Notify the user that an agent's typing status has changed.
     *
     * @param body
     */
    notifyIsTyping : function(body) {
        'use strict';
        var isAgentTyping = body.isTyping;

        if (isAgentTyping === true) {
            var agent = this.users[body.agentId];
            agent.isTyping = isAgentTyping;
            this.updateTypingCell(agent, true);

            var agentTypeOut;
            if (agent.type === 'active_participant') {
                agentTypeOut = chatConfig.activeAgentTypeOut;
            } else if (agent.type === 'passive_participant') {
                agentTypeOut = chatConfig.passiveAgentTypeOut;
            } else {
                agentTypeOut = chatConfig.supervisorTypeOut;
            }

            if (agentTypeOut !== undefined) {
                this.clearTypingTimer(agentTypeOut);
            }

            agentTypeOut = setTimeout(function() {
                //if (this.users !== undefined) {
                agent.isTyping = false;
                //this.updateTypingCell(agent, false);
                jQuery("#AgentStatus").html("");

                // }
            }, chatConfig.agentTypingTimeout);
            this.timeouts.push(agentTypeOut);
        }
    },

    /**
     * Notify the user of a new chat message.
     *
     * @param body
     */
    notifyNewMessage : function(body) {
        'use strict';
        this.addMessageToHistoryList(body);
        //var date = new Date(body.timestamp);
        var senderType = body.senderType.toLowerCase();
        //var dateMessage = body.displayName + ' (' + date.toLocaleTimeString() + ')';


        if (senderType === "customer") {

            // this is likely to be caused by customer refreshing page
            //this.writeResponse(dateMessage, chatConfig.writeResponseClassDate);
            //this.writeResponse(body.message, chatConfig.writeResponseClassSent);

        } else {
            //this.writeResponse(dateMessage, chatConfig.writeResponseClassAgentDate);
            //var chatMessageClass = (senderType === "bot" ? chatConfig.writeResponseClassChatbot : chatConfig.writeResponseClassResponse);
            if (body.type === "widget") {
                //this.writeResponse(body.data.text, chatMessageClass);
                this.createWidgets(body.data);
            }
            else {
                //this.writeResponse(body.message, chatMessageClass);
            }
        }

    },

    /**
     * Notify the user of a new page push message
     *
     * @param body
     */
    notifyNewPagePushMessage : function(body) {
        'use strict';
        this.addMessageToHistoryList(body);

        /*var sentDate = new Date(body.timestamp), url = body.pagePushURL; //name = body.displayName;

         //Check for Co-Browse enabled.
        var sessionKey = avayaGlobal.getParameterByName('key', body.pagePushURL);
        var dateMessage;

        if (sessionKey !== null) {
            console.debug('WebChat/CoBrowse: Recieved Co-Browse page push request for session ' + sessionKey +
                    '.');
            this.isPagePushKey = true;

            // show the Co-Browsing notification
            dateMessage = 'System: (' + new Date().toLocaleTimeString() + ')';
            this.writeResponse(dateMessage, chatConfig.writeResponseClassSystem);
            this.writeResponse("", chatConfig.writeResponseClassSystem);
        } else {
            // show the Page-Push notification
            dateMessage = name + ' (' + sentDate.toLocaleTimeString() + ')';
            var systemMessage = chatConfig.pagePushMessageText.concat(url);
            this.writeResponse(dateMessage, chatConfig.writeResponseClassAgentDate);
            this.writeResponse(systemMessage, chatConfig.writeResponseClassSystem);
        }*/
    },

    /**
     * Notify the user that an agent has joined the chat.
     *
     * @param body
     */
    notifyNewParticipant : function(body) {
        'use strict';
        chatUI.disableControls(false);
        this.stopOnHoldMessages();

        var id = body.agentId;
        var role = body.role;

        // assign chatbot name here. The UI will then use whatever name was assigned in AutomationController.
        if (id === 'AvayaAutomatedResource') {
            this.chatBotName = body.displayName;
        }

        var agents = body.participants;
        this.updateUsers(agents);

        if (this.checkAgentVisibility(id, role)) {
            chatUI.notifyNewParticipantUI();
            const conversationId = Vue.prototype.$conversationId;
            const mChatHistory = Vue.prototype.$config.mahboubChatHistoryBaseUrl;
            if(conversationId !=null && conversationId !=undefined && conversationId.trim() !='' &&
                mChatHistory !=null && mChatHistory !=undefined && mChatHistory.trim() !='') {
                const mahboubChatHistory = Vue.prototype.$labels["chatbox.MAHBOUB_CHAT_HISTORY_TEXT"] + ' ' + mChatHistory + "conversationId=" + conversationId;
                webChat.sendChatMessage('', mahboubChatHistory);
            }
            //jQuery("#comments").disabled = false;
            //this.writeResponse(chatConfig.agentJoinedMessage, chatConfig.writeResponseClassSystem);
        }


        if (body.webOnHoldComfortGroup !== undefined && body.webOnHoldComfortGroup.length > 0) {
            this.webOnHoldComfortGroups = body.webOnHoldComfortGroup[0];
        }
    },

    checkAgentVisibility : function(id, role) {
        'use strict';

        // check if notifications are allowed/required
        var announceBot = (id === 'AvayaAutomatedResource' && !chatConfig.suppressChatbotPresence);
        var announceObserve = (role === 'supervisor_observe' && chatConfig.notifyOfObserve);
        var announceBarge = (role === 'supervisor_barge' && chatConfig.notifyOfBarge && !chatConfig.notifyOfObserve);

        // if notifications are allowed/required, display them
        if (announceBot || announceObserve || announceBarge || role === 'active_participant') {
            return true;
        }
        return false;
    },

    /**
     * Notify the user that an agent has left the chat.
     *
     * @param body
     */
    notifyParticipantLeave : function(body) {
        'use strict';
        this.addMessageToHistoryList(body);

        jQuery("#agentWaiting").hide();
        jQuery("#agentConnected").hide();
        jQuery("#agentDisconnected").show();
        document.getElementById("sendMessageButton").style.backgroundColor = Vue.prototype.$disableColor;
        document.getElementById("sendMessageButton").style.borderColor = Vue.prototype.$disableColor;

        var id = body.agentId;
        var agents = body.participants;

        // workaround to make sure Chrome closes on a two-node cluster
        if (body.endChatFlag) {
            chatConfig.dontRetryConnection = true;
        }

        // check if this user is actually present in the users to avoid multiple displays of "An agent has left".
        // This does not affect the chatbot.
        var isAgentContained = false;
        for (var i = 0; i < agents.length; i++) {
            if (agents[i].id === id) {
                isAgentContained = true;
                break;
            }
        }

        var leaveReason = body.leaveReason.toLowerCase();

        // check if this is the chatbot, and if it is to be suppressed.
        var suppressBot = (leaveReason === 'escalate' && chatConfig.suppressChatbotPresence);

        // if there are no users, check if this is a transfer.
        if (Object.keys(body.participants).length === 0) {
            chatUI.disableControls(true);
            this.startOnHoldMessages();

            if (leaveReason === 'transfer') {
                //this.writeResponse(chatConfig.transferNotificationText, chatConfig.writeResponseClassSystem);
            } else if (leaveReason === 'requeue') {
                //this.writeResponse(chatConfig.requeueNotificationText, chatConfig.writeResponseClassSystem);
            } else if (leaveReason === 'escalate' && !chatConfig.suppressChatbotPresence) {
                //this.writeResponse(chatConfig.chatbotTransferNotification, chatConfig.writeResponseClassSystem);
            } else if (leaveReason === 'transfer_to_user') {
                //this.writeResponse(chatConfig.transferToUserText, chatConfig.writeResponseClassSystem);
            } else {
                //this.writeResponse(chatConfig.agentLeftMessage, chatConfig.writeResponseClassSystem);
            }

        } else {
            // Let the user know that an agent has left, unless it's the chatbot and chatbot notifications are suppressed.
            if (!suppressBot && !isAgentContained) {
                //this.writeResponse(chatConfig.agentLeftMessage, chatConfig.writeResponseClassSystem);
            }
        }

        this.updateUsers(agents);
    },

    /**
     * Notifies the user that they have entered the chat.
     *
     * @param body
     */
    notifyRequestChat : function(body) {
        console.log('notifyRequestChat')
        'use strict';
        this.guid = body.guid;
        this.custDetails.displayName = body.intrinsics.name;
        this.ak = body.authenticationKey;

        var wrid = body.workRequestId;
        this.customerFeedback.chatsessionId = wrid;
        webChat.sendFeedback(true);
        if (chatSocket.retries > 0) {
            chatSocket.resetConnectionAttempts();
        }

        // if the customer has already been connected, don't play the on
        // hold messages
        if (!chatConfig.previouslyConnected) {
            //this.writeResponse(chatConfig.chatOpenedText, chatConfig.writeResponseClassSystem);
            chatConfig.previouslyConnected = true;

            if (!body.isEmailValid) {
                //this.writeResponse(chatConfig.invalidEmailAddressText, chatConfig.writeResponseClassSystem);
                this.custDetails.email = '';
            }

            this.webOnHoldComfortGroups = body.webOnHoldComfortGroups[0];
            this.webOnHoldURLs = body.webOnHoldURLs[0];
            this.startOnHoldMessages();
        } else {
            //this.writeResponse(chatConfig.successfulReconnectionText, chatConfig.writeResponseClassSystem);
        }
    },

    /**
     * Notifies the user that no agent could be found to route the chat to.
     */
    notifyRouteCancel : function() {
        'use strict';
        //this.writeResponse(chatConfig.routeCancelText, chatConfig.writeResponseClassSystem);
        chatConfig.dontRetryConnection = true;
    },

    /**
     * Notifies the user of a new file transfer.
     */
    notifyFileTransfer : function(body) {
        'use strict';
        console.info('WebChat: Notifying of file transfer', body);
        var agentname = body.agentName;
        var uuid = body.uuid;
        var wrid = body.workRequestId;
        var url = links.getFileDownloadUrl(uuid, wrid);
        var filename = body.name;
        var timestamp = new Date().toLocaleString();
        //var dateMessage = agentname + ' (' + timestamp + ')';
        //this.writeResponse(dateMessage, chatConfig.writeResponseClassAgentDate);

        var message = Vue.prototype.$labels["chatbox.FILE_NOTIFY_AGENT_MESSAGE"] ? Vue.prototype.$labels["chatbox.FILE_NOTIFY_AGENT_MESSAGE"] : '{3}';
        message = message.replace('{0}', agentname);
        message = message.replace('{1}', filename);
        message = message.replace('{2}', timestamp);
        message = message.replace('{3}', url);

        this.addMessageToHistoryList({"displayName": agentname, "message": message});

        //this.writeResponse(message, chatConfig.writeResponseClassResponse);
    },

    /**
     * Notifies the user that a video or voice chat is being opened.
     *
     * @param body
     */
    notifyVideoOrVoice : function(body) {
        'use strict';
        console.debug('WebChat: ' + body);
    },

    /**
     * Called when the customer starts typing.
     * The current behavious is that pressing Enter (keycode 13) will send the chat message.
     * @param event
     */
    onType(event) {
        'use strict';
        try{
            document.getElementById("comments").style.height = "5px";
            document.getElementById("comments").style.height = (document.getElementById("comments").scrollHeight)+"px";
        }
        catch(e){
            console.log("Error in detecting mobile version");
        }
        if (event.keyCode === 13 && chatUI.getChatMessage() != '\n' && !avayaGlobal.isStringEmpty(chatUI.getChatMessage().trim())) {
            webChat.sendChatMessage();
        } else {
            webChat.startTypingTimer()
        }
    },

    /**
     * Play the Web-On-Hold messages inside a specific array.
     *
     * @param array
     *                of Web-On-Hold comfort messages or URLs.
     */
    playOnHoldMessage : function(array) {
        'use strict';
        var currentMsg;

        // if this has a urls array, it's a WebOnHold URL
        // otherwise, it's a comfort message
        if (array.urls !== undefined) {
            currentMsg = array.urls[array.currentSequence];
            var msgText = array.description + ': ' + currentMsg.url;
            this.writeResponse(msgText, chatConfig.writeResponseClassSystem);

        } else {
            currentMsg = array.messages[array.currentSequence];
            this.writeResponse(currentMsg.message, chatConfig.writeResponseClassSystem);
        }

        array.currentSequence++;
        if ((array.numberOfMessages !== undefined && array.currentSequence >= array.numberOfMessages) ||
            (array.urls !== undefined && array.currentSequence >= array.urls.length)) {
            array.currentSequence = 0;
        }

    },

    /**
     * Sends a close chat request to the server.
     */
    quitChat : function() {
        'use strict';
        // Prevent reconnect attempts if customer clicks 'Close' while chat is
        // reconnecting
        chatConfig.dontRetryConnection = true;
        chatSocket.manualClose = true;
        //this.clearAllTimeouts();
        for (var i = 0; i < this.timeouts.length; i++) {
            clearTimeout(this.timeouts[i]);
        }
        if (chatConfig.webSocket !== null && chatConfig.webSocket !== undefined && chatConfig.webSocket.readyState === chatConfig.webSocket.OPEN) {
            var closeRequest = {
                'apiVersion' : '1.0',
                'type' : 'request',
                'body' : {
                    'method' : 'closeConversation'
                }
            };
            chatSocket.sendMessage(closeRequest);
        }
    },

    /**
     * Sends a chat message to the server. If the message box is empty, nothing
     * is sent.
     */
    sendChatMessage : function(fileUploadURL, mahboubChatHistory) {
        'use strict';
        var text = chatUI.getChatMessage();

        if(mahboubChatHistory !=null && mahboubChatHistory !=undefined && mahboubChatHistory.trim() !='') {
            text = mahboubChatHistory;
        }

        var body = {"intrinsics": this.custDetails.displayName, "message": text};

        if (!avayaGlobal.isStringEmpty(text.trim())) {
            if(mahboubChatHistory ==null || mahboubChatHistory ==undefined || mahboubChatHistory.trim() =='') {
                this.addMessageToHistoryList(body);
            }

            jQuery("#chatcontentcontainer").scrollTop(jQuery("#chatcontentcontainer")[0].scrollHeight);
            jQuery("#comments").val("");
            chatUI.focusTextField();
            chatUI.scrollChatTrail();
            $("#enterButton").attr("disabled", "disabled");
            $("#enterButton").text(Vue.prototype.$labels["chatbox.BTN_SENDING"]);

            var message = {
                'apiVersion' : '1.0',
                'type' : 'request',
                'body' : {
                    'method' : 'newMessage',
                    'message' : text,
                    'type': 'text',
                    'data': {
                        'message': text
                    },
                    'customData': this.customData
                }
            };
            chatSocket.sendMessage(message);
            chatUI.clearMessageInput();
        }
        //Send Fileuploadurl
        if(fileUploadURL !== null && fileUploadURL !== undefined && !avayaGlobal.isStringEmpty(fileUploadURL)) {
            var fileUploadMessage = {
                'apiVersion' : '1.0',
                'type' : 'request',
                'body' : {
                    'method' : 'newMessage',
                    'message' : fileUploadURL,
                    'type': 'text',
                    'data': {
                        'message': text
                    },
                    'customData': this.customData
                }
            };

            var fileUploadURLPieces = fileUploadURL.replace(/\/\s*$/,'').split('/');
            var fileName = fileUploadURLPieces[fileUploadURLPieces.length-1];
            var fileUploadBody = {"intrinsics": this.custDetails.displayName, "message": fileName};
            this.addMessageToHistoryList(fileUploadBody);
            //jQuery("#cutomerChatMessage").html("<img border='0' src='../../images/file-icon.png'></a>" + fileName);

            /*jQuery("#cutomerChatMessage").html("<a href='" + fileUploadURL+ "' target='_blank' download=''>" +
                    "<img border='0' src='../../images/file-icon.png'></a>" + fileName);*/
            chatSocket.sendMessage(fileUploadMessage);
            $("#filename").html('');
            jQuery("#fileinput").val('');
        }
    },

    /**
     * Sends a widget response to the server. If the message box is empty, nothing
     * is sent.
     */
    sendWidgetMessage: function () {
        'use strict';
        //var timestamp = new Date().toLocaleTimeString();
        //var custName = this.custDetails.displayName;
        //var dateMessage = custName + ' (' + timestamp + ')';
        //this.writeResponse(dateMessage, chatConfig.writeResponseClassDate);
        //this.writeResponse(this.getAttribute('value'), chatConfig.writeResponseClassSent);

        var message = {
            'apiVersion': '1.0',
            'type': 'request',
            'body': {
                'method': 'newMessage',
                'message': this.getAttribute('value'),
                'type': 'customResponse',
                'data': {
                    "message": this.getAttribute('value'),
                    "correlationId": this.getAttribute('data-correlationId')
                },
                'customData': this.customData
            }
        };

        chatSocket.sendMessage(message);

    },

    /**
     * Lets the agents know that the customer is typing.
     *
     * @param isUserTyping
     */
    sendIsTyping(isUserTyping) {
        'use strict';
        var isTypingMessage = {
            'apiVersion' : '1.0',
            'type' : 'request',
            'body' : {
                'method' : 'isTyping',
                'isTyping' : isUserTyping
            }
        };

        // update lastisTypingSent timestamp
        this.lastIsTypingSent = Date.now();

        chatSocket.sendMessage(isTypingMessage);
    },

    /**
     * Ping the WebSocket to see if it is still open on both ends. JavaScript
     * doesn't have an API for this, so this is a workaround.
     */
    sendPing : function() {
        'use strict';
        var ping = {
            'apiVersion' : '1.0',
            'type' : 'request',
            'body' : {
                'method' : 'ping'
            }
        };
        chatSocket.sendMessage(ping);
    },

    /**
     * Start playing the on hold messages, if either the messages or the URLs
     * are defined. The intervals are defined in the OCP Admin.
     */
    startOnHoldMessages : function() {
        'use strict';
        var onHoldUrlsDefined = (this.webOnHoldURLs !== null && this.webOnHoldURLs.urls.length > 0);
        var onHoldMessagesDefined = (this.webOnHoldComfortGroups !== null && this.webOnHoldComfortGroups.messages.length > 0);

        if (!onHoldUrlsDefined && !onHoldMessagesDefined) {
            console.warn('WebChat: On Hold messages are not defined!');
        }

        if (onHoldMessagesDefined) {
            // sort the WebOnHoldComfortGroups according to sequence
            var newMessages = this.webOnHoldComfortGroups.messages.sort(function(a, b) {
                return (a.sequence - b.sequence);
            });
            this.webOnHoldComfortGroups.messages = newMessages;
            this.webOnHoldComfortGroups.currentSequence = 0;

            this.onHoldComfortInterval = setInterval(function() {
                this.playOnHoldMessage(this.webOnHoldComfortGroups);
            }, this.webOnHoldComfortGroups.delay * 1000);
            this.timeouts.push(this.onHoldComfortInterval);
        }

        if (onHoldUrlsDefined) {
            this.webOnHoldURLs.currentSequence = 0;

            this.onHoldUrlInterval = setInterval(function() {
                this.playOnHoldMessage(this.webOnHoldURLs);
            }, this.webOnHoldURLs.holdTime * 1000);
            this.timeouts.push(this.onHoldUrlInterval);
        }

    },

    stopOnHoldMessages : function() {
        'use strict';
        clearInterval(this.onHoldUrlInterval);
        clearInterval(this.onHoldComfortInterval);
    },

    /**
     * Start the customer's typing timer.
     */
    startTypingTimer() {
        'use strict';
        var isTypingTimer = Date.now();
        var timerExpiryTime = this.lastIsTypingSent + this.timeBetweenMsgs;

        if (isTypingTimer >= timerExpiryTime) {
            this.sendIsTyping(true);
        }

    },

    /**
     * Update the typing image for a specific agent.
     *
     * @param agent
     * @param isTyping
     */
    updateTypingCell : function(agent, isTyping) {
        'use strict';
        var agentTypingHtml= "";
        if(isTyping) {
            agentTypingHtml="<small>"+Vue.prototype.$labels["chatbox.CHAT_AGENT_TYPING_TEXT"]+"</small>";
        }
        jQuery("#AgentStatus").html(agentTypingHtml);

        /*var imageSrc;
        if (agent.agentType === 'active_participant' || agent.agentType === 'passive_participant') {
            imageSrc = isTyping === true ? chatConfig.agentTypingImage : chatConfig.agentImage;
        } else {
            imageSrc = isTyping === true ? chatConfig.supervisorTypingImage : chatConfig.supervisorImage;
        }

        // find which index this agent is. If the index is -1 (likely due to timing issues with a single agent),
        // default to 0
        var index = Object.keys(webChat.users).indexOf(agent);
        if (index < 0) {
            index = 0;
        }
        chatUI.updateUserImage(index, imageSrc, "", isTyping === true ? agent.displayName.concat(' is typing') : agent.displayName);*/

    },

    /**
     * Update the users section when an agent leaves or joins.
     *
     * @param agents
     */
    updateUsers : function(agents) {
        'use strict';
        this.users = {};
        chatUI.clearUsers();

        if (agents !== undefined) {
            for (var i = 0; i < agents.length; i++) {
                var agent = agents[i];
                if (this.checkAgentVisibility(agent.id, agent.type) || agent.type === 'passive_participant') {
                    console.debug('WebChat: Adding agent with id ' + agent.id + ' and name ' + agent.name);

                    /*var src = (agent.type.substring(0, 10) === 'supervisor') ? chatConfig.supervisorImage
                            : chatConfig.agentImage;
                    var className = '';
                    chatUI.updateUserImage(i, src, className,agent.name);*/

                    this.users[agent.id] = {
                        displayName : agent.name,
                        isTyping : false,
                        agentType : agent.type
                    };
                }

            }
        }
    },

    /**
     * split text string on white-space and add white-space
     * after each entry to maintain message structure
     *
     *
     * @param text
     */
    splitText : function(text) {
        'use strict';
        var textArray = text.split(" ");
        var output = [];
        for (var i = 0; i < textArray.length; i++) {
            output.push(textArray[i]);
            output.push(" ");
        }

        return output;

    },

    /**
     * Writes the specified text out to the transcript box and includes an
     * autoscroll mechanism.
     *
     * @param text
     * @param msgClass
     */
    writeResponse : function(text, msgClass) {
        'use strict';

        var paragraph = document.createElement('p');
        paragraph.className = msgClass;

        // get message split by white-space
        var textArray = this.splitText(text);

        // append each element of the message as a string or a link
        for (var i = 0; i < textArray.length; i++) {

            var span = document.createElement('span');
            // check that URLs have at least one character in the path else display as text
            // have to use "indexOf === 0", as IE does not support the startsWith method
            if ((textArray[i].indexOf("http://") === 0 && textArray[i].length > 7) ||
                (textArray[i].indexOf("https://") === 0 && textArray[i].length > 8)) {

                this.appendLink(textArray[i], 'blank', false, span);
            }
            //if http(s) appears without a qualifing '://', it will be displayed as normal text
            else {
                span.textContent = textArray[i];
            }

            paragraph.appendChild(span);
        }
        chatUI.appendParagraph(paragraph);

    },

    addMessageToHistoryList : function(body) {
        var today = new Date();
        var id = today.getMilliseconds();
        var h = today.getHours();
        var m = today.getMinutes();
        var s = today.getSeconds();

        // add a zero in front of numbers<10
        h = avayaGlobal.checkTime(h);
        m = avayaGlobal.checkTime(m);
        s = avayaGlobal.checkTime(s);
        var messageTime = h + ":" + m + ":" + s;

        var sender = ' ';
        var senderShotName = '';
        var message= {};

        if(body.intrinsics != null && body.intrinsics !=undefined && body.intrinsics != "") { //Customer
            sender = body.intrinsics;
            senderShotName = sender.charAt(0).toUpperCase();
            message = {"id": id, "messageTime": messageTime, "messageText": body.message, "senderShotName": senderShotName, "sender": sender, type: "customer", sentTime: new Date()};

        } else if(body.displayName != null && body.displayName != undefined && body.displayName!= "") { //Agent
            sender = body.displayName;
            senderShotName = sender.charAt(0).toUpperCase();
            //var messageText = "";
            var url = null;
            if(body.method == "newPushPageMessage") {
                url = body.pagePushURL;

                var link = $("#agentMessageLink");
                link.href = url;
                link.text = url;
                link.target = ('_' + 'blank');

            } else {
                var textToCheck = body.message;
                var expression = /((https?:\/\/)|(\/)(..\/))(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/gm ///(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~:%]*)*(#[\w-]*)?(\?[^\s]*)?/gi;
                var regex = new RegExp(expression);
                var match = ''; var splitTextList = []; var startIndex = 0;
                while ((match = regex.exec(textToCheck)) != null) {
                    splitTextList.push({text: textToCheck.substr(startIndex, (match.index - startIndex)), type: 'text'});
                    var cleanedLink = textToCheck.substr(match.index, (match[0].length));
                    url = cleanedLink;
                    splitTextList.push({text: cleanedLink, type: 'link'});
                    startIndex = match.index + (match[0].length);
                }
                if (startIndex < textToCheck.length) splitTextList.push({text: textToCheck.substr(startIndex), type: 'text'});
            }
            message = {"id": id, "messageTime": messageTime, "messageText": splitTextList, "senderShotName": senderShotName, "sender": sender, type: "agent", sentTime: new Date()};
        } else {
            message = {"id": id, "messageTime": messageTime, "messageText": "All Agents have left the conversation",  "senderShotName": "", "sender": "", type: "agentDisconnected", sentTime: new Date()}
        }
        this.messageList.push(message);
        chatUI.scrollChatTrail()

    },

    /* This function is used to plot widgets */
    createWidgets: function (data) {
        'use strict';
        var type = data.widgetType.split('|');

        if (type[0].toLowerCase() === (widgetConfig.selector).toLowerCase()) {
            this.createSelectorElement(data, type[1]);
        }
        else if (type[0].toLowerCase() === (widgetConfig.click).toLowerCase()) {
            this.createClickElement(data, type[1]);
        }
        else {
            console.warn("This type of widget (" + type + ") is not supported");
        }

    },

    createSelectorElement: function (data, type) {
        'use strict';
        var divElement = document.createElement('div');
        divElement.className = chatConfig.writeResponseClassResponse;

        if (type.toLowerCase() === (widgetConfig.radio).toLowerCase()) {
            this.createRadioElement(data, divElement);
        }

        divElement.append(document.createElement("br"));
        chatUI.appendParagraph(divElement);
    },

    createClickElement: function (data, type) {
        'use strict';
        var divElement = document.createElement('div');
        divElement.className = chatConfig.writeResponseClassResponse;

        if (type.toLowerCase() === (widgetConfig.button).toLowerCase()) {
            this.createButtonElement(data, divElement);
        }

        divElement.append(document.createElement("br"));
        chatUI.appendParagraph(divElement);

    },

    createRadioElement: function (data, divElement) {
        'use strict';
        for (var item in data.selectItems ) {
            var radioInput = document.createElement("label");
            var radioElement = document.createElement("input");
            radioElement.type = "radio";
            radioElement.value = data.selectItems[item].product;
            radioElement.id =data.selectItems[item].id;
            radioElement.name = data.selectorType;
            radioElement.setAttribute("data-correlationId", data.correlationId);
            radioElement.addEventListener('click', this.sendWidgetMessage);
            radioInput.append(radioElement);
            divElement.append(radioInput);
            var spanElement = document.createElement('span');
            var textElement = document.createTextNode(data.selectItems[item].product);
            spanElement.append(textElement);
            spanElement.setAttribute("class", "radio-widget");

            divElement.append(spanElement);
            divElement.append(document.createElement("br"));
        }

    },

    createButtonElement: function (data, divElement) {
        'use strict';
        for (var item in data.selectItems )  {
            var btnElement = document.createElement("BUTTON");
            btnElement.setAttribute("class", "button-widget");
            btnElement.setAttribute("id",data.selectItems[item].id);
            btnElement.setAttribute("value", data.selectItems[item].product);
            btnElement.setAttribute("data-correlationId", data.correlationId);
            btnElement.addEventListener('click', this.sendWidgetMessage);
            btnElement.append(document.createTextNode(data.selectItems[item].product));
            divElement.append(btnElement);
        }
    },

    /**
     * Utility function to set the workflow type for routing.
     *
     * @param newWorkflowType
     */
    setWorkflowType : function(newWorkflowType) {
        'use strict';
        this.workflowType = newWorkflowType;
    },

    /**
     * Gather the required chat elements

     gatherChatElements : function() {
        'use strict';
        var find = avayaGlobal.getEl;
    }, */

    /**
     * Call this to set up this.
     */
    setupWebChat: function() {
        'use strict';

        // check if this browser supports required features
        avayaGlobal.detectBrowserSupport();
        links.setupSecurity();

        // set up the UI
        chatUI.setup();

        // check if there was a chat in progress before reloading
        chatSocket.reloadAfterRefresh();

        ewt.requestEwt();
        chatLogon.saveAttributeCount();

        // If chat is in progress, prevent user from accidentally closing the page.
        // Can't override default message due to security restrictions
        // so the value returned here doesn't really matter.
        window.onbeforeunload = function() {

            if (this.initCalled) {
                chatSocket.setupRefresh();
                return "You're about to end your session, are you sure?";
            }
        };
    },

    attachContinueClose: function() {
        var input = document.getElementById('fileinput');
        var attachedFile=input.files[0].name;

        $( "#attach_close" ).dialog({
            resizable: false,
            height: "auto",
            width:"96%",
            title: Vue.prototype.$labels["chatbox.WINDOW_CONTINUE_CLOSE_ATTACH"] +" "+ attachedFile +" ",
            modal: true,
            buttons:  {
                "1":{
                    id:'confirm',
                    text: Vue.prototype.$labels["chatbox.WINDOW_CONTINUE"],
                    click: function() {
                        var input = document.getElementById('fileinput');
                        var fileName = input.files[0].name;
                        var accepts = input.accept;
                        accepts = accepts.replace(/\./g, '')
                        var  _validFileExtensions = accepts.split(",");

                        //_validFileExtensions
                        var fileExtension = fileName.replace(/^.*\./, '');
                        var tlnValid = false;
                        if (fileName.length > 0) {
                            for (var j = 0; j < _validFileExtensions.length; j++) {
                                if(_validFileExtensions[j].toLowerCase()==fileExtension.toLowerCase()){
                                    tlnValid=true;
                                    break;

                                }
                            }
                        }
                        if (tlnValid) {
                            var size = input.files[0].size;
                            if ((size / (1024 * 1024)) <= 2)
                                $("#filename").html(fileName);
                            else {
                                //this.showDialogue(Vue.prototype.$labels["chatbox.FILE_SIZE_NOT_SUPPORTED"], Vue.prototype.$labels["chatbox.FILE_UPLOAD_FAILED"]);
                                //Show Dialog Start
                                var dialog =  "<div id=file_size <p>"+Vue.prototype.$labels["chatbox.FILE_SIZE_NOT_SUPPORTED"]+"</p></div>";
                                $('body').append(dialog).addClass( "main-wrapper" );
                                $( "#file_size" ).dialog({
                                    title:Vue.prototype.$labels["chatbox.FILE_UPLOAD_FAILED"],
                                    resizable: false,
                                    height: "auto",
                                    modal: true,
                                    buttons:  {
                                        "1":{
                                            id:'closefile',
                                            text:Vue.prototype.$labels["chatbox.WINDOW_CLOSE"],
                                            click: function() {

                                                var divid=document.getElementById('file_size');
                                                if(divid!=null && divid!=undefined)
                                                    divid.remove();
                                                $(this).dialog("close");
                                            },

                                            "class":"colordialog"
                                        }
                                    }

                                })
                                var bcolor= Vue.prototype.$color;//getColor(defaultchannel,false,appname);
                                if(bcolor!=null && bcolor!=undefined ){
                                    $('.colordialog').css("background-color",bcolor)
                                    $('.colordialog').css("border-color",bcolor)
                                }
                                //Show Dialog End

                                $("#filename").html('');
                                jQuery("#fileinput").val('');
                            }
                        }
                        else {
                            //this.showDialogue(Vue.prototype.$labels["chatbox.FILE_TYPE_NOT_SUPPORTED"], Vue.prototype.$labels["chatbox.FILE_UPLOAD_FAILED"]);
                            //Show Dialog Start
                            dialog =  "<div id=file_size <p>"+Vue.prototype.$labels["chatbox.FILE_TYPE_NOT_SUPPORTED"]+"</p></div>";
                            $('body').append(dialog).addClass( "main-wrapper" );
                            $( "#file_size" ).dialog({
                                title:Vue.prototype.$labels["chatbox.FILE_UPLOAD_FAILED"],
                                resizable: false,
                                height: "auto",
                                modal: true,
                                buttons:  {
                                    "1":{
                                        id:'closefile',
                                        text:Vue.prototype.$labels["chatbox.WINDOW_CLOSE"],
                                        click: function() {

                                            var divid=document.getElementById('file_size');
                                            if(divid!=null && divid!=undefined)
                                                divid.remove();
                                            $(this).dialog("close");
                                        },

                                        "class":"colordialog"
                                    }
                                }

                            })
                            bcolor= Vue.prototype.$color;//getColor(defaultchannel,false,appname);
                            if(bcolor!=null && bcolor!=undefined ){
                                $('.colordialog').css("background-color",bcolor)
                                $('.colordialog').css("border-color",bcolor)
                            }
                            //Show Dialog End
                        }
                        $( this ).dialog("close");
                    },
                    "class":"filedialog1"

                },
                "2":{
                    id:'cancel',
                    text:Vue.prototype.$labels["chatbox.WINDOW_CLOSE"],
                    click: function() {
                        $( this ).dialog("close");
                        document.getElementById("fileinput").value = "";

                        document.getElementById("fileinput").value = "";

                    },

                    "class":"filedialog2"

                }
            }
        });
        //attachmentIsActive
        $("#attach_close").dialog("open");
        var color = Vue.prototype.$color;
        if(color!=null && color!=undefined ){
            document.getElementById("cancel").style.backgroundColor = color;
            document.getElementById("cancel").style.borderColor = color;
            document.getElementById("confirm").style.backgroundColor = color;
            document.getElementById("confirm").style.borderColor = color;
        }
    },
    //Not used
    attachFile: function() {
        var input = document.getElementById('fileinput');
        var fileName = input.files[0].name;
        var accepts = input.accept;
        accepts = accepts.replace(/\./g, '')
        var array = accepts.split(",");
        if (this.validateSingleInput(fileName, array)) {

            var size = input.files[0].size;
            if ((size / (1024 * 1024)) <= 2)
                $("#filename").html(fileName);
            else {
                this.showDialogue(Vue.prototype.$labels["chatbox.FILE_SIZE_NOT_SUPPORTED"], Vue.prototype.$labels["chatbox.FILE_UPLOAD_FAILED"]);
                $("#filename").html('');
                jQuery("#fileinput").val('');
            }
        }
        else {
            this.showDialogue(Vue.prototype.$labels["chatbox.FILE_TYPE_NOT_SUPPORTED"], Vue.prototype.$labels["chatbox.FILE_UPLOAD_FAILED"]);
        }
    },

    validateSingleInput: function(fileName,_validFileExtensions) {
        var fileExtension = fileName.replace(/^.*\./, '');
        var tlnValid = false;
        if (fileName.length > 0) {
            for (var j = 0; j < _validFileExtensions.length; j++) {
                if(_validFileExtensions[j].toLowerCase()==fileExtension.toLowerCase()){
                    tlnValid=true;
                    break;

                }
            }
            if(!tlnValid)
                return false;
        }
        return tlnValid;
    },

    //Not used
    showDialogue: function(msg,title){
        var dialog =  "<div id=file_size <p>"+msg+"</p></div>";
        $('body').append(dialog).addClass( "main-wrapper" );
        $( "#file_size" ).dialog({
            title:title,
            resizable: false,
            height: "auto",
            modal: true,
            buttons:  {
                "1":{
                    id:'closefile',
                    text:Vue.prototype.$labels["chatbox.WINDOW_CLOSE"],
                    click: function() {

                        var divid=document.getElementById('file_size');
                        if(divid!=null && divid!=undefined)
                            divid.remove();
                        $(this).dialog("close");
                    },

                    "class":"colordialog"
                }
            }

        })
        var bcolor= Vue.prototype.$color;//getColor(defaultchannel,false,appname);
        if(bcolor!=null && bcolor!=undefined ){
            $('.colordialog').css("background-color",bcolor)
            $('.colordialog').css("border-color",bcolor)
        }
    },

    handleFileSelect: function(){
        if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
            alert('The File APIs are not fully supported in this browser.');
            return;
        }
        var input = document.getElementById('fileinput');
        if (!input) {
            alert("Um, couldn't find the fileinput element.");
        }
        else if (!input.files) {
            alert("This browser doesn't seem to support the `files` property of file inputs.");
        }
        else if (!input.files[0]) {
            alert("Please select a file before clicking 'Load'");
        }
        else {
            var file = input.files[0];
            var filename=input.files[0].name;
            console.log('filename:',filename)
            var fr = new FileReader();
            //  fr.onload =
            // fr.readAsText(file);
            fr.readAsDataURL(file);
            fr.onloadend= function ()
            {
                //this.receivedText(fr,filename);
                //var formData = new FormData();
                //  formData.append('file', file)
                //var uri=jQuery("#context").val()+"/web/operations";
                //var templateDirVal = jQuery("#templateDir").val();
                //params={"textMessage":fr.result,operation:"processFile","templateDir":templateDirVal,"filename":filename};

                //ajaxPostCall(uri,params,processTextResponse,processTextResponse);
                $("#filename").html('');
                jQuery("#fileinput").val('');
            }
        }
    },

    receivedText: function(fr,filename) {
        console.log("fr", fr)
        console.log("filename", filename)

        //var formData = new FormData();
        //  formData.append('file', file)
        //var uri=jQuery("#context").val()+"/web/operations";
        //var templateDirVal = jQuery("#templateDir").val();
        //params={"textMessage":fr.result,operation:"processFile","templateDir":templateDirVal,"filename":filename};

        //ajaxPostCall(uri,params,processTextResponse,processTextResponse);
        $("#filename").html('');
        jQuery("#fileinput").val('');

    },
    sendSessionEndAndQuitChat: function() {
        var message = {
            'apiVersion' : '1.0',
            'type' : 'request',
            'body' : {
                'method' : 'newMessage',
                'message' : Vue.prototype.$labels['chatbox.Session_End_Text'],
                'type': 'text',
                'data': {
                    'message': Vue.prototype.$labels['chatbox.Session_End_Text']
                },
                'customData': {}
            }
        };
        if (chatConfig.webSocket !== null && chatConfig.webSocket !== undefined) {
            chatSocket.sendMessage(message);
            this.quitChat()
        }
    },

    redirect: function() {
        console.log('webChat.Redirect called', Chat)
        setTimeout(function(){}, 5000);
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
        if(webChat.isCreateJourney){
            Chat.methods.createJourney()
        }
        webChat.sendFeedback(false);
        var redirectedURL = document.referrer;

        setTimeout(function () {
            if(Vue.prototype.$RtaAppPath == "RtaAppChatBot") {
                console.log("Webchat.redirect-RtaAppChatBot")
                window.location.replace(window.location.origin + "/RtaAppChatBot/jsp/chat/closewindow.jsp")
            } else if(Vue.prototype.$RtaWebChatBot){
                console.log("Webchat.redirect-RtaWebChatBot")
                window.parent.postMessage(JSON.stringify({close: 'true'}), '*');
            } else if(Vue.prototype.$RtaAppPath == "RtaVisualIVR") {
                console.log("Webchat.redirect-RtaVisualIVR")
                window.location.replace(redirectedURL);
            } else {
                console.log("Webchat.redirect-RtaAppChat||RtaDimpChat")
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                var lang = urlParams.get('lang');
                var mobile = urlParams.get('mobile') === "false" ? "false" : "true";
                var appname = urlParams.get('appname');
                var ver = urlParams.get('ver');
                var skillset = urlParams.get('skillset');

                window.location.replace(window.location.origin + window.location.pathname
                    + "?lang=" + lang
                    + "&mobile=" + mobile
                    + (appname === "undefined" || appname == null ? "" : "&appname=" + appname )
                    + (ver === "undefined" || ver == null ? "" : "&ver=" +  ver )
                    + ((appname != "undefined" && appname != null && appname.toLowerCase() === "dubaidrive" && !(skillset === "undefined" || skillset == null)) ? "&skillset=" + skillset : "")
                );
            }
        }, 3000);
    },

    //When agent closes the chat conversation
    feedbackShow: function() {
        var timeout = parseInt(Vue.prototype.$labels['chatbox.CUSTOMER_RESPONSE_TIMEOUT_IN_MIN']);
        var lastCustomerMessage = this.getLastCustomerMessage();
        if(lastCustomerMessage) {
            var customerLastMessageTime = lastCustomerMessage.sentTime;
            webChat.isFeedbackShow = true;
            if(new Date(customerLastMessageTime.setMinutes(customerLastMessageTime.getMinutes() + timeout)).getTime() < new Date().getTime()) {
                const urlParams = new URLSearchParams(window.location.search);
                const appname = urlParams.get('appname');
                if(Vue.prototype.$RtaAppPath == "RtaAppChatBot" ||
                    Vue.prototype.$RtaAppPath == "RtaDimpChat" ||
                    (appname != "undefined" && appname != null && appname.toLowerCase() === "dubaidrive")) {
                    this.continueCloseDubai()
                } else {
                    this.continueClose()
                }
            } else {
                $("#chatFeedback").show();
                for (const element of document.querySelectorAll(".panel-footer")) {
                    element.style.zIndex = -1
                }
                Chat.methods.findCustomer();
            }
        } else {
            var agentFirstMessageTime = this.messageList[0].sentTime;
            if(new Date(agentFirstMessageTime.setMinutes(agentFirstMessageTime.getMinutes() + timeout)).getTime() < new Date().getTime()) {//In case NO messages sent by customer older than x min since session connected with agent
                const urlParams = new URLSearchParams(window.location.search);
                const appname = urlParams.get('appname');
                if(Vue.prototype.$RtaAppPath == "RtaAppChatBot" ||
                    Vue.prototype.$RtaAppPath == "RtaDimpChat" ||
                    (appname != "undefined" && appname != null && appname.toLowerCase() === "dubaidrive")) {
                    this.continueCloseDubai()
                } else {
                    this.continueClose()
                }
            } else {
                webChat.redirect();
            }
        }

    },

    sendFeedback: function(isChatStart) {
        console.log('isChatStart:',isChatStart);
        if(!webChat.sentFeedback && this.customerFeedback.chatsessionId !==null && this.customerFeedback.chatsessionId.trim() !=="") {
            const urlParams = new URLSearchParams(window.location.search);
            var customerFeedback = webChat.customerFeedback
            customerFeedback.chatEndDate = new Date();
            customerFeedback.agentId = 0;
            customerFeedback.channel = Vue.prototype.$channel
            customerFeedback.appName = Vue.prototype.$appname
            customerFeedback.lang = urlParams.get('lang');
            customerFeedback.appVersion = urlParams.get('ver');
            customerFeedback.source = Vue.prototype.$config.hostname
            customerFeedback.mobileOrWeb = urlParams.get('mobile') === "false" ? "false" : "true";

            http
                .post("/saveCustomerFeedback", customerFeedback)
                .then(response => {
                    console.log(response.data);
                    if(!isChatStart) {
                        webChat.sentFeedback = true;
                        chatUI.sendFeedback();
                        webChat.redirect();
                    }

                }).catch(e => {
                console.log("post error",e);
            }).then(function () {
                console.log("last then!");
            });
        }
    },

    getLastCustomerMessage: function() {
        for(var i=(this.messageList.length - 1); i>=0; i--) {
            if(this.messageList[i].type == "customer") {
                return this.messageList[i];
            }
        }
        return null;
    },

    continueClose: function(){

        $( "#cont_close" ).dialog({
            resizable: false,
            height: "auto",
            width:"96%",
            title:Vue.prototype.$labels['chatbox.CONTINUE_CLOSE'],
            modal: true,
            buttons:  {
                "1":{
                    id:'confirm',
                    text:Vue.prototype.$labels["chatbox.WINDOW_CONTINUE"],
                    click: function() {
                        $( this ).dialog("close");

                        //Requee
                        window.removeEventListener('beforeunload', this.beforeWindowUnload)
                        webChat.isFeedbackShow = false;
                        const urlParams = new URLSearchParams(window.location.search);
                        var lang = urlParams.get('lang');
                        var mobile = urlParams.get('mobile') === "false" ? "false" : "true";
                        var appname = urlParams.get('appname');
                        var ver = urlParams.get('ver');
                        window.location.replace(window.location.origin + window.location.pathname
                            + "?lang=" + lang
                            + "&mobile=" + mobile
                            + (appname === "undefined" || appname == null ? "" : "&appname=" + appname )
                            + (ver === "undefined" || ver == null ? "" : "&ver=" +  ver )
                            + "&name=" + Vue.prototype.$name
                            + "&email=" + Vue.prototype.$email
                            + "&phone=" + Vue.prototype.$phone
                            + "&skillset=" + chatLogon.skillSetCode
                        );
                    },
                    "class":"filedialog1"

                },
                "2":{
                    id:'cancel',
                    text:Vue.prototype.$labels["chatbox.WINDOW_CLOSE"],
                    click: function() {
                        $( this ).dialog("close");
                        if(webChat.isFeedbackShow) {
                            $("#chatFeedback").show();
                            for (const element of document.querySelectorAll(".panel-footer")) {
                                element.style.zIndex = -1
                            }
                            Chat.methods.findCustomer();
                        } else {
                            webChat.redirect()
                        }
                    },

                    "class":"filedialog2"

                }
            }
        });
        var color = Vue.prototype.$color;
        if(color!=null && color!=undefined ){
            document.getElementById("cancel").style.backgroundColor = color;
            document.getElementById("cancel").style.borderColor = color;
            document.getElementById("confirm").style.backgroundColor = color;
            document.getElementById("confirm").style.borderColor = color;
        }

    },

    continueCloseDubai: function(){
        const urlParams = new URLSearchParams(window.location.search);
        var lang = urlParams.get('lang');

        $( "#cont-close-dubai" ).show();

        const alertContentDivElement = document.getElementById('cont-close-dubai');
        const contCloseWindowText = Vue.prototype.$labels["chatbox.CONTINUE_CLOSE_DUBAI_TEXT"];
        const contCloseWindowAlertText =Vue.prototype.$labels["chatbox.CONTINUE_CLOSE_DUBAI_ALERT_TEXT"];

        const contentParagraphDivElement = document.createElement('div');
        contentParagraphDivElement.style = 'padding:.5em 1em;';

        var textArray = contCloseWindowText.split('<p>')
        for(var i=0; i<textArray.length; i++) {
            const paragraphElement = document.createElement('p');
            paragraphElement.appendChild(document.createTextNode(textArray[i]));
            contentParagraphDivElement.appendChild(paragraphElement);
        }

        var alertContainerDivElement = document.createElement('div');

        if(lang !=null && lang !=undefined && lang=='ar') {
            alertContainerDivElement.style = 'display: grid; text-align:right; align-items: center; grid-template-columns: 1fr 16fr; column-gap: 0.5em; color:#000000; background-color: #FFFCD0; width:100%; padding:0.5em; font-family: RTA; font-size:12px;';
        } else {
            alertContainerDivElement.style = 'display: grid; text-align:left; align-items: center; grid-template-columns: 1fr 16fr; column-gap: 0.5em; color:#000000; background-color: #FFFCD0; width:100%; padding:0.5em; font-family: RTA; font-size:12px;';
        }

        var alertImageDivElement = document.createElement('div');
        var alertImageElement = document.getElementById('alert-image');

        alertImageDivElement.appendChild(alertImageElement);

        var alertTextDivElement = document.createElement('div');
        var alertSpanElement = document.createElement('span');
        alertSpanElement.appendChild(document.createTextNode(contCloseWindowAlertText));
        alertTextDivElement.appendChild(alertSpanElement);

        alertContentDivElement.appendChild(contentParagraphDivElement);
        alertContentDivElement.appendChild(alertContainerDivElement);

        alertContainerDivElement.appendChild(alertImageDivElement);
        alertContainerDivElement.appendChild(alertTextDivElement);

        $( "#cont-close-dubai" ).dialog({
            resizable: false,
            height: "auto",
            width:"96%",
            title:Vue.prototype.$labels['chatbox.CONTINUE_CLOSE_DUBAI_TITLE'],
            modal: true,
            dialogClass: "ddDialogClass",
            create: function(event, ui){
                console.log(ui)
                $('.ui-dialog').wrap('<div class="ddDialogClass" />');
            },
            open: function(event, ui){
                console.log(ui)
                $('.ui-widget-overlay').wrap('<div class="ddDialogClass" />');
            },
            buttons:  {
                "1":{
                    id:'cancel',
                    text:Vue.prototype.$labels["chatbox.CONTINUE_CLOSE_DUBAI_WINDOW_CLOSE"],
                    click: function() {
                        $( this ).dialog("close");
                        if(webChat.isFeedbackShow) {
                            $("#chatFeedback").show();
                            for (const element of document.querySelectorAll(".panel-footer")) {
                                element.style.zIndex = -1
                            }
                            Chat.methods.findCustomer();
                        } else {
                            webChat.redirect()
                        }
                    },
                },
                "2":{
                    id:'confirm',
                    text:Vue.prototype.$labels["chatbox.CONTINUE_CLOSE_DUBAI_WINDOW_CONTINUE"],
                    click: function() {
                        $( this ).dialog("close");

                        //Requee
                        window.removeEventListener('beforeunload', this.beforeWindowUnload)
                        webChat.isFeedbackShow = false;

                        var mobile = urlParams.get('mobile') === "false" ? "false" : "true";
                        var appname = urlParams.get('appname');
                        var ver = urlParams.get('ver');
                        window.location.replace(window.location.origin + window.location.pathname
                            + "?lang=" + lang
                            + "&mobile=" + mobile
                            + (appname === "undefined" || appname == null ? "" : "&appname=" + appname )
                            + (ver === "undefined" || ver == null ? "" : "&ver=" +  ver )
                            + "&name=" + Vue.prototype.$name
                            + "&email=" + Vue.prototype.$email
                            + "&phone=" + Vue.prototype.$phone
                            + "&skillset=" + chatLogon.skillSetCode
                        );
                    }
                }
            }
        });
        var color = Vue.prototype.$color;
        if(color!=null && color!=undefined ){
            document.getElementById("cancel").style.backgroundColor = "#ffffff";
            document.getElementById("cancel").style.borderColor = "#ffffff";
            document.getElementById("cancel").style.color = color;
            document.getElementById("confirm").style.backgroundColor = color;
            document.getElementById("confirm").style.borderColor = color;
            document.getElementById("confirm").style.color = "#ffffff";

            document.getElementById("ui-id-1").style.color = color;
        }

    }
};
